module.exports = __webpack_public_path__ + "static/image/service/pc/ceo@3x.jpg?235c93ae";